import { InView } from 'react-intersection-observer';
import style from '../knear.module.scss'
import animations from '@styles/animations.module.scss'
import Image from 'next/image'
import { PreviewBlockPoint } from '../knear-state';

const PreviewSection = ({ title, subtitle, image, points, id }: PreviewBlockPoint) => {
    return (
        <>
            <section className={`${style.section}`}>
                <div className={`${style.container} ${style.preview} ${id % 2 === 0 ? style.preview_reversed : null}`}>
                    <div className={style.preview__text}>
                        <InView triggerOnce={true}>
                            {({ inView, ref, entry }: any) => {
                                if (inView) {
                                    entry?.target.classList.add(animations.active);
                                }
                                return (
                                    <div ref={ref} className={`${style.preview__title} ${animations.scroll__animation}`}>
                                        {title}
                                    </div>
                                )
                            }}
                        </InView>
                        <InView triggerOnce={true}>
                            {({ inView, ref, entry }: any) => {
                                if (inView) {
                                    entry?.target.classList.add(animations.active);
                                }
                                return (
                                    <div ref={ref} className={`${style.container__subtitle} ${style.container__subtitle_left} ${animations.scroll__animation}`}>
                                        {subtitle}
                                    </div>
                                )
                            }}
                        </InView>
                        {
                            points?.map((item: string, index: number) => {
                                const first = 0;
                                return (
                                    <InView key={index} triggerOnce={true}>
                                        {({ inView, ref, entry }: any) => {
                                            if (inView) {
                                                entry?.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div ref={ref} className={`${style.container__points} ${style.container__list__points} ${first === index ? style.container__list__points_first : null} ${animations.scroll__animation}`}>
                                                    {item}
                                                </div>
                                            )
                                        }}
                                    </InView>
                                )
                            })
                        }
                    </div>

                    <InView triggerOnce={true}>
                        {({ inView, ref, entry }: any) => {
                            if (inView) {
                                entry?.target.classList.add(animations.active);
                            }
                            return (
                                <div ref={ref} className={` ${style.preview__image} ${animations.scroll__animation}`}
                                >
                                    <Image sizes="800px 200px" layout='fill' src={image} alt={title} />
                                </div>
                            )
                        }}
                    </InView>
                </div>
            </section>
            <hr />
        </>
    )
}

export default PreviewSection;
